import { render, staticRenderFns } from "./sfc-simple-button.vue?vue&type=template&id=0f40b01b&scoped=true&lang=pug&"
import script from "./sfc-simple-button.vue?vue&type=script&lang=js&"
export * from "./sfc-simple-button.vue?vue&type=script&lang=js&"
import style0 from "./sfc-simple-button.vue?vue&type=style&index=0&id=0f40b01b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40b01b",
  null
  
)

export default component.exports